const API_BASE = import.meta.env.VITE_API_URL;
const API_VERSION = import.meta.env.VITE_VERSION;
export const API_URL = `${API_BASE}/${API_VERSION}`;
